"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("../Style.css");

var _idbReactIconlib = require("@identitybuilding/idb-react-iconlib");

var _idbReactIconlib2 = _interopRequireDefault(_idbReactIconlib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuoteItem = function QuoteItem(props) {
  return _react2.default.createElement(
    _react.Fragment,
    null,
    props.length === 0 ? _react2.default.createElement(
      "div",
      { className: "modNoData" },
      "No description received"
    ) : _react2.default.createElement(
      "div",
      { className: "container" },
      _react2.default.createElement(
        "div",
        { id: "quoteblock" },
        _react2.default.createElement(
          "div",
          { id: "foto" },
          _react2.default.createElement("img", { src: props.image })
        ),
        _react2.default.createElement(
          "div",
          { id: "content" },
          _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "span",
              { id: "left" },
              _react2.default.createElement(_idbReactIconlib2.default, { name: "QuoteOpenFill" })
            ),
            _react2.default.createElement(
              "p",
              { id: "part1" },
              props.text
            ),
            _react2.default.createElement(
              "span",
              { id: "right" },
              _react2.default.createElement(_idbReactIconlib2.default, { name: "QuoteClosedFill" })
            )
          ),
          _react2.default.createElement(
            "span",
            { id: "author" },
            _react2.default.createElement(
              "p",
              null,
              props.author
            )
          )
        )
      )
    )
  );
};

exports.default = QuoteItem;